import { render, staticRenderFns } from "./AcessarAtaPartesEnvolvidasView.vue?vue&type=template&id=9ef12116"
import script from "./AcessarAtaPartesEnvolvidasView.vue?vue&type=script&lang=js"
export * from "./AcessarAtaPartesEnvolvidasView.vue?vue&type=script&lang=js"
import style0 from "./AcessarAtaPartesEnvolvidasView.vue?vue&type=style&index=0&id=9ef12116&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports